
import { chunk } from 'lodash'

export default {
  name: 'BaseSwiper',
  props: {
    swiperData: {
      type: Array,
      default: () => [],
    },
    // 상세 세부 옵션 지정하고 싶을 때
    options: {
      type: Object,
      default: () => ({}),
    },
    loop: {
      type: Boolean,
      default: false,
    },
    wrapperClass: {
      type: String,
      default: null
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    showNavigation: {
      type: Boolean,
      default: false,
    },
    showController: {
      type: Boolean,
      default: false,
    },
    showProgress: {
      type: Boolean,
      default: false,
    },
    chunkCount: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      isMounted: false,
      progressWidth: 0,
      activeIndex: 0,
      autoStatus: true,
      paginationEl: `.swiper-pagination-${this._uid}`
    }
  },
  computed: {
    defaultSwiperOptions () {
      const slidesPerView = typeof this.options.slidesPerView === 'number'
        ? this.options.slidesPerView
        : 1

      const canLoop = this.loop &&
        this.chunkList.length > 1 &&
        this.chunkList.length > slidesPerView

      return {
        loop: canLoop,
        autoplay: this.autoplay ? { delay: 3000 } : false,
        pagination: this.showPagination || this.showController
          ? {
              el: this.paginationEl,
              clickable: true,
              type: 'fraction',
              renderFraction (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' +
                '<span class="divide">/</span>' +
                '<span class="' + totalClass + '"></span>'
              }
            }
          : false,

        navigation: this.showController || this.showNavigation
          ? {
              nextEl: `.swiper-button-next-${this._uid}`,
              prevEl: `.swiper-button-prev-${this._uid}`
            }
          : false
      }
    },
    mergedSwiperOptions () {
      const merged = { ...this.defaultSwiperOptions }

      Object.keys(this.options).forEach((key) => {
        if (key === 'autoplay') {
          // autoplay 특별 처리
          if (this.options[key] === false) {
            merged[key] = false
          } else if (this.options[key] === true) {
            merged[key] = { delay: 3000 }
          } else if (typeof this.options[key] === 'object') {
            merged[key] = { delay: 3000, ...this.options[key] }
          } else {
            merged[key] = this.options[key]
          }
        } else if (key === 'pagination') {
          if (this.options[key] === false) {
            merged[key] = false
          } else if (this.options[key] === true) {
            merged[key] = {
              clickable: true,
              type: 'fraction',
              renderFraction (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' + '<span class="' + totalClass + '"></span>'
              }
            }
          } else if (typeof this.options[key] === 'object') {
            merged[key] = {
              clickable: true,
              type: 'fraction',
              renderFraction (currentClass, totalClass) {
                return '<span class="' + currentClass + '"></span>' + '<span class="' + totalClass + '"></span>'
              },
              ...this.options[key]
            }
          } else {
            merged[key] = this.options[key]
          }
        } else {
          merged[key] = this.options[key]
        }
      })
      return merged
    },
    chunkList () {
      if (this.chunkCount > 0) {
        return chunk(this.swiperData, this.chunkCount)
      } else {
        return this.swiperData
      }
    },
    activeIndexes () {
      return this.chunkList.map((_, i) => {
        return i <= this.currentIndex
      })
    },
    progress () {
      const active = this.activeIndexes.filter(Boolean).length
      return (active / this.chunkList.length) * 100
    }
  },
  mounted () {
    this.isMounted = true

    this.$nextTick(() => {
      const swiper = this.$refs.swiperEl?.swiper
      if (!swiper) { return }

      const slidesPerView = typeof this.options.slidesPerView === 'number'
        ? this.options.slidesPerView
        : 1

      const totalSlides = this.chunkList.length

      if (totalSlides <= slidesPerView) {
        swiper.destroy()
        this.activeIndex = 0
      }
    })
  },
  methods: {
    swiperChange () {
      const swiper = this.$refs.swiperEl?.swiper
      this.activeIndex = this.mergedSwiperOptions.loop ? swiper.realIndex : swiper.activeIndex
      this.$emit('slide-change', this.activeIndex)
      this.isEnd = swiper.isEnd
    },
    swiperChangeStart () {
      this.$emit('slideChangeTransitionStart')
    },
    swiperDestroy () {
      const swiperInstance = this.getSwiperInstance()
      if (swiperInstance) {
        swiperInstance.destroy()
        this.activeIndex = 0
      }
    },
    getSwiperInstance () {
      return this.$refs.swiperEl?.swiper
    },
    stopSwiper () {
      this.$refs.swiperEl.swiper.autoplay.stop()
      this.autoStatus = false
      this.$emit('autoplay-pause')
    },
    playSwiper () {
      if (this.mergedSwiperOptions.autoplay !== false) {
        this.$refs.swiperEl.swiper.autoplay.start()
      }
      this.autoStatus = true
      this.$emit('autoplay-play')
    },
  }
}
